import {
  getPageCategoryContent,
  getPageContent,
} from '@backmarket/http-api/src/api-specs-content'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { usePageParamsFromRoute } from './usePageParamsFromRoute'

export function useFetchContent() {
  const pathParams = usePageParamsFromRoute()
  const endpoint = isEmpty(pathParams.pageCategory)
    ? getPageContent
    : getPageCategoryContent

  return useHttpFetch(endpoint, { pathParams })
}
